import fetcher from '@app/utils/fetcher';
import useConfiguration from '@store/hooks/useConfiguration';
import type { MutableRefObject} from 'react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useSWR from 'swr';

import CategoryGridItem from './CategoryGridItem';
import NavigationAnchor from './NavigationAnchor';
import type { ICategoryNode, ICurrencyItem, INavigationItem, SidebarApiResponse } from './types';

interface IProps {
  navigationItems: INavigationItem[];
  currencies: ICurrencyItem[];
  divRef: MutableRefObject<any>;
  onClose: () => void;
}

export default function DefaultScreen(props: IProps) {
  const { t } = useTranslation();
  const { culture } = useConfiguration();

  const [selectedNode, setSelectedNode] = useState<ICategoryNode | undefined>();

  const { data, error } = useSWR<SidebarApiResponse>(`/${culture}/catalog/category-tree`, fetcher, {
    revalidateOnFocus: false,
  });

  const onClose = () => {
    setSelectedNode(undefined);
    props.onClose();
  };

  if (error) return <div>Chyba {error}</div>;
  if (!data) return <></>;

  return (
    <div
      className="w-full h-full flex flex-col bg-white z-10 shadow-md overflow-x-hidden"
      ref={props.divRef}>
      <div className="flex justify-between items-center bg-primary text-white p-4">
        <span className="text-xl font-bold font-heading uppercase">{t('Menu')}</span>
        {props.currencies.length > 1 && (
          <>
            <div className="flex gap-2 px-2 text-xl currency-list">
              {props.currencies.map(item => (
                <a key={item.url} href={item.url} className={`h-full inline-flex items-center justify-center flex-auto p-0 hover:underline ${item.active ? 'font-semibold underline' : ''}`}>
                  {item.code}
                </a>
              ))}
            </div>
          </>
        )}
        <button className="p-1" role="button" onClick={onClose}>
          <i className="fa-solid fa-times fa-xl" />
        </button>
      </div>
      <div
        className={`grid relative ease-in-out duration-300 transition-transform text-black ${selectedNode ? '-translate-x-full' : 'translate-x-0'
          }`}>
        {data.map(node => (
          <CategoryGridItem
            key={node.categoryId}
            onClick={n => setSelectedNode(n)}
            onBack={() => setSelectedNode(undefined)}
            selectedNodeId={selectedNode?.categoryId}
            {...node}
          />
        ))}

        {props.navigationItems.length > 0 && (
          <>
            <div className="w-full flex items-center py-3 px-4 text-sm font-medium text-gray-500 bg-gray-50">
              Ostatné stránky
            </div>
            {props.navigationItems.map(item => (
              <div key={item.url} className="flex items-center border-b border-gray-100">
                <NavigationAnchor title={item.title} href={item.url}>
                  <span>{item.title}</span>
                </NavigationAnchor>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
